
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
    props: {
        carOccupancy: {
            type: Object as PropType<{ id: number; title: number; percent: number; }>,
            required: true
        }
    },
    setup(props) {
        const lineClasses = computed(() => {
            return {
                'bg-green-400': props.carOccupancy.percent <= 50,
                'bg-yellow-400': props.carOccupancy.percent > 50 && props.carOccupancy.percent < 80,
                'bg-red-400': props.carOccupancy.percent >= 80
            }
        })

        return {
            lineClasses
        }
    }
})
